import { gql } from '@apollo/client/core';

export const MEMO_FIELDS = gql`
  fragment MemoFields on Memo {
    id
    title
    description
    startDate
    endDate
    icon
    createdByName
  }
`;
